import {copilotLocalStorage} from '@github-ui/copilot-chat-helpers/copilot-local-storage'
import type {CopilotChatRepo} from '@github-ui/copilot-chat-types'
import {useCallback, useState} from 'react'

export type UseLastUsedRepositoryReturn = [
  lastUsedRepo: CopilotChatRepo | null,
  setLastUsedRepo: (repo: CopilotChatRepo | null) => void,
]

/**
 * Custom hook that manages the last used repository state and automatically
 * loads it from local storage on mount.
 */
export function useLastUsedRepository(): UseLastUsedRepositoryReturn {
  const [lastUsedRepo, setLastUsedRepo] = useState<CopilotChatRepo | null>(() => {
    return copilotLocalStorage.getLastUsedRepository()
  })

  const setRepo = useCallback((repo: CopilotChatRepo | null) => {
    setLastUsedRepo(repo)
    if (repo) {
      copilotLocalStorage.setLastUsedRepository(repo)
    }
  }, [])

  return [lastUsedRepo, setRepo]
}
